<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__wrapper">
        <div class="footer__left">
          <router-link :to="translations.i18nRoute({ name: 'home' })">
            <img class="footer__logo" src="@icons/logo.svg" alt="logo" />
          </router-link>
          <p><img src="@icons/location.svg" alt=""> {{ company?.companyAddress }}</p>
          <p><img src="@icons/mail.svg" alt=""> <a :href="'mailto:' + company?.emailFrom">{{ company?.emailFrom }}</a></p>
          <p><img src="@icons/phone.svg" alt=""> <a :href="'tel:' + company?.companyPhoneNumber">{{ company?.companyPhoneNumber }}</a></p>
        </div>
        <div class="footer__columns">
          <div class="footer__column">
            <h6>{{ t('footer.language') }}</h6>
            <ui-language-switcher />
          </div>
          <div class="footer__column">
            <h6>{{ t('footer.services') }}</h6>
            <router-link
                v-for="category in categories"
                :key="category.node.uuid"
                :to="translations.i18nRoute({ name: 'store', query: { categoriesSlugs: category.node.slug } })"
            >
              {{ category.node.name }}
            </router-link>
          </div>
          <div class="footer__column">
            <h6>{{ t('footer.company') }}</h6>
            <router-link :to="translations.i18nRoute({ name: 'faq' })">{{ t('docs.faq.title') }}</router-link>
            <router-link :to="translations.i18nRoute({ name: 'terms' })">{{ t('docs.terms.title') }}</router-link>
            <router-link :to="translations.i18nRoute({ name: 'policy' })">{{ t('docs.policy.title') }}</router-link>
            <p @click="scrollTo('contact', 'home')">{{ t('footer.contact') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer__bottom">
      <p>{{ actualYear }} © COMPANYNAME. {{ t('footer.rights') }}</p>
    </div>
  </footer>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
import {computed} from "vue";
import {useCompanyStore} from "@/stores/company.js";
import {useI18n} from "vue-i18n";
import {useCategoryStore} from "@/stores/category.js";
import UiLanguageSwitcher from "@/components/ui/ui-language-switcher.vue";
import {useRouter} from "vue-router";

const {t} = useI18n()
const router = useRouter()
const companyStore = useCompanyStore()
const categoryStore = useCategoryStore()

const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})
const categories = computed(() => categoryStore.categories)

const actualYear = computed(() => new Date().getFullYear());

const scrollTo = (id, routeName) => {
  router.push({
    name: routeName
  }).then(scroll(id, 400));
}
</script>

<style lang="scss" scoped>
.footer {
  &__wrapper {
    padding-block: 35px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  &__logo {
    margin-bottom: 15px;
  }

  &__left {
    display: flex;
    flex-direction: column;
    gap: 8px;

    & p {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      max-width: 350px;

      color: $white;
      font-size: 16px;

      & img {
        margin-top: 3px;
      }

      & a {
        transition: 0.2s;

        @include hover {
          color: #c5c5c5;
        }
      }
    }
  }

  &__columns {
    display: flex;
    gap: 75px;
  }

  &__column {
    display: flex;
    flex-direction: column;
    gap: 10px;

    & h6 {
      margin-bottom: 3px;
      color: $white;
      font-size: 18px;
      font-weight: 700;
      text-transform: uppercase;
    }

    & a, p {
      transition: 0.2s;
      cursor: pointer;
      color: $white;
      font-size: 16px;

      @include hover {
        color: #c5c5c5;
      }
    }
  }

  &__bottom {
    background-color: #FF001F;
    padding: 10px 25px;

    & p {
      color: #F3F3F3;
      text-align: center;
      font-family: Montserrat, sans-serif;
      font-size: 13px;
      font-weight: 700;
      line-height: 150%;
    }
  }
}

@media (max-width: 1000px) {
  .footer {
    &__wrapper {
      flex-direction: column;
      align-items: center;
      gap: 50px;
    }

    &__left {
      align-items: center;
    }
  }
}

@media (max-width: 600px) {
  .footer {
    &__columns {
      flex-direction: column;
      align-items: center;
      gap: 30px;
    }

    &__column {
      align-items: center;
    }
  }
}
</style>